import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        drawerContentContainer: {
            maxW: {base: '100%', lg: remCalc(480)},
            borderRadius: {base: 0, lg: `${remCalc(16)} 0 0 ${remCalc(16)}`},
        },
        drawerCloseButton: {
            backgroundColor: 'background.dark',
            color: 'background.default',
            borderRadius: '100%',
            top: remCalc(24),
            right: {base: remCalc(16), lg: remCalc(24)},
        },
        drawerHeaderContainer: {
            pt: remCalc(88),
        },
        drawerBodyContainer: {
            padding: {base: remCalc(16), lg: remCalc(32)},
            gap: remCalc(8),
            display: 'flex',
            flexDirection: 'column',
        },
        seeAllButton: {
            marginLeft: remCalc(8),
            mt: remCalc(16),
        },
        drawerCardHeader: {
            flexDirection: 'column',
            alignItems: 'start',
            gap: remCalc(4),
        },
        drawerCardContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            border: `${remCalc(1)} solid`,
            borderColor: 'border.light',
            borderRadius: remCalc(8),
            padding: remCalc(16),
            gap: remCalc(16),
            whiteSpace: 'normal',
            _hover: {
                borderColor: 'border.dark',
            },
        },
        drawerCardCurrent: {
            borderColor: 'button.button-shop-default',
        },
        currentVariantContainer: {
            display: 'flex',
            whiteSpace: 'unset',
            border: `${remCalc(1)} solid`,
            borderColor: 'border.light',
            borderRadius: remCalc(8),
            gap: remCalc(16),
            padding: {base: remCalc(16), lg: remCalc(24)},
            alignItems: 'center',
            justifyContent: 'space-between',
            w: '100%',
        },
        currentVariantInfoContainer: {
            flexDirection: 'column',
            gap: remCalc(16),
        },
        outOfStockInfoContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            gap: remCalc(8),
            mt: remCalc(16),
        },
        currentVariantInfo: {
            display: 'flex',
            flexDirection: 'column',
            gap: remCalc(16),
        },
        currentVariantTitle: {
            textAlign: 'left',
            fontWeight: 'normal',
            fontSize: remCalc(14),
        },
        drawerCardTitle: {
            textAlign: 'left',
            fontWeight: 'normal',
        },
        variantsImage: {
            width: '100%',
            maxWidth: remCalc(311),
            aspectRatio: '4.17 / 1',
            objectFit: 'cover',
        },
        priceContainer: {
            alignItems: 'center',
            gap: {
                base: remCalc(4),
                sm: remCalc(4),
                md: 'xsmall.base',
                lg: 'xsmall.base',
            },
        },
        outOfStockLabel: {
            height: '100%',
        },
        rightIconButton: {
            height: 'fit-content',
        },
        rightIcon: {
            color: 'background.default',
            backgroundColor: 'black',
            borderRadius: '100%',
            border: 'none',
            p: remCalc(6),
        },
        subModelIdentifier: {
            fontSize: remCalc(10),
            color: 'text.secondary',
        },
    },
}
